<template>
  <div class="app text-left leading-none lg:text-lg">
    <Topbar v-if="role === 'free'" />

    <PendingTopbar />
    <Alert />
    <div class="relative overflow-auto" id="content">
      <router-view />
    </div>
    <Navbar class="block overflow-hidden xl:hidden" />
    <OurPlans v-model:isVisible="ourPlansIsActive" />
    <div id="AdModalPortal"></div>
    <div id="confirm-upgrade"></div>
  </div>
</template>

<script>
import { onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Navbar from "@/components/Navbar";
import OurPlans from "@/components/Modals/OurPlans";
import PendingTopbar from "./components/PendingTopbar.vue";
import Alert from "@/components/Alert";
import Topbar from "@/components/Topbar.vue";
export default {
  components: { PendingTopbar, Navbar, OurPlans, Alert, Topbar },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      store.dispatch("AUTHENTICATE");
      const { data } = await store.dispatch("GET_USER");

      const status = computed(() => store.state.status);
      const first_signin = computed(() => store.state.first_signin);
      console.log("firsttt", first_signin);

      await store.dispatch("GET_MEMBERSHIPS");
      await store.dispatch("GET_TITLES_SUBTITLES");
      if (status.value) {
        console.log("ref");
        await store.dispatch("GET_TOTAL_USERS");
        await store.dispatch("GET_FAVORITES_ADS", { idUser: data.id });
        await store.dispatch("GET_FAVORITES_TIKTOKS", { idUser: data.id });
        await store.dispatch("GET_FAVORITES_TOP_BRANDS", { idUser: data.id });
        await store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
        await store.dispatch("GET_TOTAL_DISCOVER", { addedFilters: null });
        await store.dispatch("GET_TOP_BRANDS");
        await store.dispatch("GET_TIKTOKS", { idUser: data.id });
        store.dispatch("GET_PREMIUM_ADS");
      } else {
        console.log("1");
        router.push("/pricing");
      }
    });

    const ourPlansIsActive = computed(() => store.state.ourPlansIsActive);
    const role = computed(() => store.state.role);
    return { ourPlansIsActive, role };
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,800;1,200;1,300;1,400&display=swap");

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app {
  display: grid;
}
#content {
  padding-bottom: 60px;
}
@media (min-width: 1280px) {
  #content {
    padding-bottom: 0px;
  }
}
</style>
